import React, { PropsWithChildren, ReactElement, useRef } from 'react'
import { Flex, ThemeUIStyleObject } from 'theme-ui'
import useOnClickOutside from 'utils/useOnClickOutside'
import { Setter } from 'utils'

export default function ActionButtonsContainer({
  children,
  sxContainer,
  setIsTooltipVisible,
}: PropsWithChildren<{
  sxContainer?: ThemeUIStyleObject
  setIsTooltipVisible?: Setter<boolean>
}>): ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)

  useOnClickOutside([containerRef], () => {
    setIsTooltipVisible?.(false)
  })

  return (
    <Flex
      ref={containerRef}
      sx={{
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        width: '9.6rem',
        height: '3.2rem',
        borderRadius: '3.2rem',
        position: 'relative',
        border: '1px solid',
        borderColor: 'blueYonder30',
        ...sxContainer,
      }}
      role="menu"
    >
      {children}
    </Flex>
  )
}
